import { ActionType, loadState } from "./types"

const setLoadDetails = (data: loadState) => {
  return {
    type: ActionType.SET_LOAD_STATUS,
    payload: data
  }
}
export default setLoadDetails
